module.exports = __webpack_public_path__ + "img/assistance5.f7f190fe.png";